(() => {
  const form = document.querySelector('[data-rm-product-form]');
  if (!form) return;

  const variantInput = form.querySelector('[data-rm-variant-id]');
  const addBtn = form.querySelector('[data-rm-add]');
  const optionSelects = [...form.querySelectorAll('[data-rm-option]')];
  const variantsEl = form.querySelector('[data-rm-variants]');
  let variants = [];

  try {
    if (variantsEl) variants = JSON.parse(variantsEl.textContent);
  } catch (err) {
    console.error(err);
  }

  const selectedOptions = () =>
    optionSelects
      .sort((a, b) => Number(a.dataset.optionPosition) - Number(b.dataset.optionPosition))
      .map((el) => el.value);

  const findVariant = () => {
    const opts = selectedOptions();
    return variants.find((v) => opts.every((opt, i) => v[`option${i + 1}`] === opt));
  };

  const sync = () => {
    if (!optionSelects.length) return;
    const variant = findVariant();
    if (!variant || !variantInput) return;
    variantInput.value = variant.id;
    if (addBtn) {
      addBtn.disabled = !variant.available;
      addBtn.textContent = variant.available
        ? addBtn.dataset.label || 'Ajouter au panier'
        : addBtn.dataset.soldOut || 'Épuisé';
    }
    const priceEl = document.querySelector('.rm-pdp__price [itemprop="price"]');
    if (priceEl && typeof variant.price === 'number') {
      // Keep Shopify money formatting approximate
      const euros = (variant.price / 100).toFixed(2).replace('.', ',');
      priceEl.textContent = `${euros}€`;
      priceEl.setAttribute('content', String(variant.price / 100));
    }
  };

  if (addBtn && !addBtn.dataset.label) {
    addBtn.dataset.label = addBtn.textContent.trim();
  }

  optionSelects.forEach((el) => el.addEventListener('change', sync));
  sync();
})();
